import { combineReducers } from 'redux';

import {
  setOpenTitleInstructionModal,
  setTitleInstructionId,
  setInlineTitleInstruction,
} from '../actions';
import { ScriptEditorAction, TitleInstructionState } from '../types';
import { Reducer } from '../../../types';

type ReducerOf<T extends keyof TitleInstructionState> = Reducer<TitleInstructionState, ScriptEditorAction, T>;

const isOpenModal: ReducerOf<'isOpenModal'> = (state = false, action) => {
  switch (action.type) {
    case setOpenTitleInstructionModal.type:
      return action.payload;

    default:
      return state;
  }
};

const instructionId: ReducerOf<'instructionId'> = (state = '', action) => {
  switch (action.type) {
    case setTitleInstructionId.type:
      return action.payload;

    default:
      return state;
  }
};

const isInline: ReducerOf<'isInline'> = (state = true, action) => {
  switch (action.type) {
    case setInlineTitleInstruction.type:
      return action.payload;

    default:
      return state;
  }
};

export default combineReducers({
  isOpenModal,
  isInline,
  instructionId,
});
